import React from "react";
import { DefaultButton, Stack, Text } from "@fluentui/react";
import { TrialRequest } from "./AdminStore";

interface TrialRequestDetailProps {
  request: TrialRequest;
  onBack: () => void;
}

function DetailRow(props: { label: string; value: string }) {
  return (
    <Stack horizontal tokens={{ childrenGap: 12 }} styles={{ root: { marginBottom: 8 } }}>
      <Text styles={{ root: { width: 160, color: "#666" } }}>{props.label}</Text>
      <Text styles={{ root: { flex: 1, wordBreak: "break-word" } }}>{props.value}</Text>
    </Stack>
  );
}

export const TrialRequestDetail: React.FunctionComponent<TrialRequestDetailProps> = ({
  request,
  onBack,
}) => {
  return (
    <Stack tokens={{ childrenGap: 16 }} styles={{ root: { maxWidth: 720, padding: 24 } }}>
      <DefaultButton text="Back to list" onClick={onBack} styles={{ root: { width: 140 } }} />
      <Text variant="xLarge">Trial Request Detail</Text>
      <DetailRow label="Submitted" value={new Date(request.createdAt).toLocaleString()} />
      <DetailRow label="Status" value={request.isDuplicate ? "Duplicate" : "New license issued"} />
      <DetailRow label="Name" value={`${request.firstName} ${request.lastName}`} />
      <DetailRow label="Email" value={request.requesterEmail} />
      <DetailRow label="Company" value={request.company} />
      <DetailRow label="Country" value={request.country} />
      <DetailRow label="Role" value={request.role} />
      <DetailRow label="Feature interest" value={request.featureInterest} />
      <DetailRow label="Report intent" value={request.reportIntent} />
      <DetailRow
        label="License expiration"
        value={request.trialLicenseExpirationDate || "—"}
      />
      <Stack tokens={{ childrenGap: 8 }}>
        <Text styles={{ root: { color: "#666" } }}>License key</Text>
        <Text
          styles={{
            root: {
              fontFamily: "Consolas, monospace",
              fontSize: 12,
              whiteSpace: "pre-wrap",
              wordBreak: "break-all",
              background: "#f5f5f5",
              padding: 12,
              borderRadius: 4,
            },
          }}
        >
          {request.trialLicenseKey || "— (duplicate request, no new license)"}
        </Text>
      </Stack>
      <Stack tokens={{ childrenGap: 8 }}>
        <Text variant="large">Emails sent</Text>
        {request.emailsSent.length === 0 && <Text>No emails logged.</Text>}
        {request.emailsSent.map((email, index) => (
          <Stack
            key={`${email.type}-${email.sentAt}-${index}`}
            styles={{
              root: {
                background: "#fafafa",
                padding: 12,
                borderRadius: 4,
                border: "1px solid #eee",
              },
            }}
            tokens={{ childrenGap: 4 }}
          >
            <Text><strong>{email.type}</strong> → {email.to}</Text>
            <Text>{email.subject}</Text>
            <Text styles={{ root: { color: "#666", fontSize: 12 } }}>
              {new Date(email.sentAt).toLocaleString()}
            </Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
